import { SxProps, Theme } from '@mui/system';

const style = {
  container: {
    width: '100%',
    overflow: 'hidden',
    backgroundColor: 'transparent',
    border: 0,
  },

  tableContainer: { maxHeight: 440, overflowY: 'auto', scrollBehavior: 'smooth' },

  header: {
    backgroundColor: 'primary.light',
    border: '1px solid',
    borderColor: 'common.borderInput',
    fontSize: 16,
    fontWeight: 500,
    color: 'black',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },

  row: {
    border: '1px solid',
    borderColor: 'common.borderInput',
    color: 'grey.800',
    fontWeight: 500,
    fontSize: 14,
  },

  cellStyle: {
    borderBottom: '1px solid',
    borderColor: 'common.borderInput',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },

  labelStyle: {
    position: 'sticky',
    top: 39,
    zIndex: 1000,
  },

  rowTime: {
    '&.MuiTableCell-body': {
      padding: 0,
    },
  },
} satisfies Record<string, SxProps<Theme>>;

export default style;
